'use client';

import { c as _c } from "react/compiler-runtime";
import SvgAdd from '@common/icon/SvgAdd';
import { cn } from '@core/utils';
import { useState } from 'react';
import type { FloatingBnbItem } from '@/app/_components/FloatingBnbController/_components/FloatingBnb';
import { FloatingBnb } from '@/app/_components/FloatingBnbController/_components/FloatingBnb';
import { ServiceSwitchDropdown } from '@/app/_components/ServiceSwitchDropdown';
import { DONATION_BNB_HOME_ITEM, DONATION_BNB_TOAST_ITEMS } from '@/app/donation/constants';
import { DONATION_ROUTES, PARTNER_SUB_DOMAIN_LIST, SUB_DOMAIN } from '@/constants';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
type DonationBnbItem = typeof DONATION_BNB_HOME_ITEM | (typeof DONATION_BNB_TOAST_ITEMS)[number];
const toFloatingBnbItem = ({
  label,
  route,
  icon
}: DonationBnbItem): FloatingBnbItem => ({
  label,
  pathname: route.pathname,
  icon,
  hasWideGlyph: route.pathname === DONATION_ROUTES.GIFTS.pathname
});
export const DonationBnb = () => {
  const $ = _c(13);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const canSwitchService = useDeviceInfoStore(_temp);
  const isToss = useDeviceInfoStore(_temp2);
  const isPartnerChannel = useDeviceInfoStore(_temp3);
  let T0;
  let t0;
  if ($[0] !== isPartnerChannel || $[1] !== isToss) {
    let t1;
    if ($[4] !== isPartnerChannel) {
      t1 = t2 => {
        const {
          route
        } = t2;
        return !isPartnerChannel || route.pathname !== DONATION_ROUTES.GIFT_TRIAL.pathname;
      };
      $[4] = isPartnerChannel;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    const toastItemList = DONATION_BNB_TOAST_ITEMS.filter(t1);
    const itemList = isToss ? [DONATION_BNB_HOME_ITEM, ...toastItemList] : toastItemList;
    T0 = FloatingBnb;
    t0 = itemList.map(toFloatingBnbItem);
    $[0] = isPartnerChannel;
    $[1] = isToss;
    $[2] = T0;
    $[3] = t0;
  } else {
    T0 = $[2];
    t0 = $[3];
  }
  let t1;
  if ($[6] !== canSwitchService || $[7] !== isDropdownOpen) {
    t1 = canSwitchService ? <div className="relative z-50"><button type="button" className="relative z-50 size-34 rounded-pill bg-Gray-white/15 transition-opacity duration-200 ease-out flex-center hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500 active:opacity-80" onClick={() => setIsDropdownOpen(_temp4)} aria-label={"\uB2E4\uB978 \uC11C\uBE44\uC2A4\uB85C \uC774\uB3D9"} aria-expanded={isDropdownOpen}><SvgAdd className={cn("size-20 text-Gray-white transition-transform duration-200", {
          "rotate-45": isDropdownOpen
        })} /></button><ServiceSwitchDropdown isOpen={isDropdownOpen} onClose={() => setIsDropdownOpen(false)} /></div> : null;
    $[6] = canSwitchService;
    $[7] = isDropdownOpen;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== T0 || $[10] !== t0 || $[11] !== t1) {
    t2 = <T0 items={t0} leading={t1} />;
    $[9] = T0;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
function _temp(state) {
  return state.subDomain !== SUB_DOMAIN.TOSS && state.subDomain !== SUB_DOMAIN.KAKAOBANK;
}
function _temp2(state_0) {
  return state_0.subDomain === SUB_DOMAIN.TOSS;
}
function _temp3(state_1) {
  return PARTNER_SUB_DOMAIN_LIST.some(partner => partner === state_1.subDomain);
}
function _temp4(prev) {
  return !prev;
}